export default __webpack_public_path__ + "static/media/ExploreTheDeep_06.fae601b9.png";